import { VisitSettlementQuery, VisitSettlementSimpleQuery } from '@dreryk/egabinet-financial-settlement-frontend-api';

import { refetchCqrsQuery } from '@dreryk/command-query-react-common';

export const useRefetchVisitSettlement = (): (() => Promise<[void, void]>) => {
   return async () =>
      Promise.all([refetchCqrsQuery(VisitSettlementQuery), refetchCqrsQuery(VisitSettlementSimpleQuery)]);
};
